import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { computed, type SetupContext } from "vue";
import type { CustomerMeDto } from "../../shared/CustomerMeDto.ts";

interface Props {
  me: CustomerMeDto;
}

// Karte "Deine Angaben" fuer eingeloggte Kunden: bestaetigen oder aendern
export default {
  template: html,
  emits: {
    onConfirm: () => true,
    onEdit: () => true,
  },
  props: {
    me: { type: Object, required: true },
  },
  setup(props: Props, { emit }: SetupContext) {
    const name = computed(() => `${props.me.firstName} ${props.me.lastName}`.trim());
    const street = computed(() => `${props.me.streetName} ${props.me.buildingNumber}`.trim());
    const place = computed(() => `${props.me.zipCode} ${props.me.city}`.trim() + (props.me.countryCode && props.me.countryCode != "CH" ? ` (${props.me.countryCode})` : ""));
    const phones = computed(() => [props.me.mobile, props.me.phoneP, props.me.phoneB].filter((p) => p && p.trim() != "").join(" · "));
    const incomplete = computed(() => street.value == "" || (props.me.zipCode || "").trim() == "" || phones.value == "");
    return {
      props,
      name,
      street,
      place,
      phones,
      incomplete,
      confirm: () => emit("onConfirm"),
      edit: () => emit("onEdit"),
    };
  },
};
